(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = this.querySelector('.announcement-bar');
      if (!this.announcementBar) return;

      // Get the parent section wrapper div (the main div with announcement-bar-section class)
      // 'this' is the <sticky-announcement-bar> custom element
      // The parent div with 'announcement-bar-section' class is where we need to add classes
      this.sectionWrapper = this.parentElement;
      
      // Verify we found the correct section wrapper
      if (!this.sectionWrapper || !this.sectionWrapper.classList.contains('announcement-bar-section')) {
        console.error('Could not find announcement-bar-section wrapper div');
        return;
      }

      this.stickyType = this.getAttribute('data-sticky-type');
      this.isAlwaysSticky = this.stickyType === 'always';
      this.announcementBarBounds = {};

      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));

      if (this.isAlwaysSticky) {
        this.sectionWrapper.classList.add('shopify-section-announcement-bar-sticky');
        // Notify header immediately for always sticky
        // Use requestAnimationFrame to ensure DOM is ready and height is calculated
        requestAnimationFrame(() => {
          this.setAnnouncementBarHeight();
          requestAnimationFrame(() => {
            window.dispatchEvent(new CustomEvent('announcementBarHeightChanged'));
          });
        });
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideAnnouncementBarOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventAnnouncementBarReveal', this.hideAnnouncementBarOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setAnnouncementBarHeight() {
      if (this.announcementBar) {
        const height = this.announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
        // Note: Don't dispatch event here - it's dispatched separately in hide/reveal/reset
        // to ensure proper timing with class changes
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventAnnouncementBarReveal', this.hideAnnouncementBarOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      window.dispatchEvent(new CustomEvent('announcementBarHeightChanged'));
    }

    createObserver() {
      // Observe the section wrapper (like header observes .section-header)
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0] && entries[0].intersectionRect) {
          this.announcementBarBounds = entries[0].intersectionRect;
        }
        observer.disconnect();
      });

      observer.observe(this.sectionWrapper);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Only process if we have bounds (wait for IntersectionObserver to set them)
      if (!this.announcementBarBounds || typeof this.announcementBarBounds.bottom === 'undefined') return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
        // Apply scrolled-past class to section wrapper (like header does)
        this.sectionWrapper.classList.add('scrolled-past-announcement-bar');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
        // Apply scrolled-past class to section wrapper (like header does)
        this.sectionWrapper.classList.add('scrolled-past-announcement-bar');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.announcementBarBounds.top) {
        // Remove scrolled-past class from section wrapper (like header does)
        this.sectionWrapper.classList.remove('scrolled-past-announcement-bar');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAlwaysSticky) return;
      // Apply sticky classes to section wrapper (like header does)
      this.sectionWrapper.classList.add('shopify-section-announcement-bar-hidden', 'shopify-section-announcement-bar-sticky');
      // Update height and notify header
      this.setAnnouncementBarHeight();
      // Use requestAnimationFrame to ensure DOM is updated before header checks
      requestAnimationFrame(() => {
        window.dispatchEvent(new CustomEvent('announcementBarHeightChanged'));
      });
    }

    reveal() {
      if (this.isAlwaysSticky) return;
      // Apply sticky classes to section wrapper (like header does)
      this.sectionWrapper.classList.add('shopify-section-announcement-bar-sticky', 'animate');
      this.sectionWrapper.classList.remove('shopify-section-announcement-bar-hidden');
      // Update height first
      this.setAnnouncementBarHeight();
      // Use double requestAnimationFrame to ensure DOM is fully updated before header checks
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.dispatchEvent(new CustomEvent('announcementBarHeightChanged'));
        });
      });
    }

    reset() {
      if (this.isAlwaysSticky) return;
      // Remove sticky classes from section wrapper (like header does)
      this.sectionWrapper.classList.remove('shopify-section-announcement-bar-hidden', 'shopify-section-announcement-bar-sticky', 'animate');
      // Update height and notify header
      this.setAnnouncementBarHeight();
      // Use requestAnimationFrame to ensure DOM is updated before header checks
      requestAnimationFrame(() => {
        window.dispatchEvent(new CustomEvent('announcementBarHeightChanged'));
      });
    }
  }

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.announcementBar = document.querySelector('sticky-announcement-bar .announcement-bar');

        this.setHeaderHeight();
        // Check offset immediately and also after a short delay to catch any timing issues
        this.setAnnouncementBarOffset();
        setTimeout(() => this.setAnnouncementBarOffset(), 100);
        requestAnimationFrame(() => this.setAnnouncementBarOffset());

        window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
          this.setHeaderHeight();
          this.setAnnouncementBarOffset();
        });

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();

        // Watch for announcement bar height changes
        if (this.announcementBar) {
          const resizeObserver = new ResizeObserver(() => {
            this.setAnnouncementBarOffset();
          });
          resizeObserver.observe(this.announcementBar);
        }

        // Listen for announcement bar state changes
        window.addEventListener('announcementBarHeightChanged', () => {
          // Use requestAnimationFrame to ensure DOM is fully updated
          requestAnimationFrame(() => {
            this.setAnnouncementBarOffset();
          });
        });
        
        // Also check offset on scroll as a fallback (for on-scroll-up mode)
        // Throttle to avoid performance issues
        let scrollCheckTimeout;
        this.scrollCheckHandler = () => {
          clearTimeout(scrollCheckTimeout);
          scrollCheckTimeout = setTimeout(() => {
            if (this.announcementBar) {
              const announcementBarWrapper = this.announcementBar.closest('sticky-announcement-bar');
              const stickyType = announcementBarWrapper ? announcementBarWrapper.getAttribute('data-sticky-type') : null;
              if (stickyType === 'on-scroll-up') {
                this.setAnnouncementBarOffset();
              }
            }
          }, 16); // ~60fps
        };
        window.addEventListener('scroll', this.scrollCheckHandler, { passive: true });
      }
  
      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      setAnnouncementBarOffset() {
        if (!this.announcementBar) {
          document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          return;
        }

        const announcementBarHeight = this.announcementBar.offsetHeight;
        
        // Check the section wrapper (like we check .section-header for header)
        // The sticky-announcement-bar element itself has the class, but classes are on its parent
        const announcementBarWrapper = this.announcementBar.closest('sticky-announcement-bar');
        if (!announcementBarWrapper) {
          document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          return;
        }
        
        // The section wrapper is the parent of sticky-announcement-bar (where classes are actually applied)
        let announcementBarSection = announcementBarWrapper.parentElement;
        if (!announcementBarSection || !announcementBarSection.classList.contains('announcement-bar-section')) {
          // Fallback: try to find it by traversing up
          let parent = announcementBarWrapper.parentElement;
          while (parent && !parent.classList.contains('announcement-bar-section')) {
            parent = parent.parentElement;
          }
          if (!parent) {
            document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
            return;
          }
          announcementBarSection = parent;
        }
        
        const isSticky = announcementBarSection.classList.contains('shopify-section-announcement-bar-sticky');
        const isHidden = announcementBarSection.classList.contains('shopify-section-announcement-bar-hidden');
        
        // Debug: log section classes
        // console.log('Section classes:', announcementBarSection.className);
        // console.log('isSticky:', isSticky, 'isHidden:', isHidden);
        
        // Get sticky type from the wrapper element
        const stickyType = announcementBarWrapper.getAttribute('data-sticky-type');
        
        // Debug: log the actual stickyType value
        // console.log('stickyType value:', stickyType, 'type:', typeof stickyType);
        
        if (!stickyType || stickyType === 'none') {
          document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          return;
        }
        
        // For "always" mode: always apply offset when not hidden
        if (stickyType === 'always') {
          if (!isHidden) {
            document.documentElement.style.setProperty('--announcement-bar-offset', `${announcementBarHeight}px`);
          } else {
            document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          }
          return;
        }
        
        // For "on-scroll-up" mode: only apply offset when sticky AND visible
        if (stickyType === 'on-scroll-up') {
            console.log('on-scroll-up', isSticky, isHidden);
          if (isSticky && !isHidden) {
            document.documentElement.style.setProperty('--announcement-bar-offset', `${announcementBarHeight}px`);
          } else {
            document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          }
          return;
        }
        
        // Default: no offset
        document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.scrollCheckHandler) {
          window.removeEventListener('scroll', this.scrollCheckHandler);
        }
      }
  
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
  
        observer.observe(this.header);
      }
  
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }
  
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.setAnnouncementBarOffset();
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        this.setAnnouncementBarOffset();
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.setAnnouncementBarOffset();
      }
  
      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }
  
      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }
  
    customElements.define('sticky-header', StickyHeader);
    
    class StaticHeader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.announcementBar = document.querySelector('sticky-announcement-bar .announcement-bar');
        
        this.setHeaderHeight();
        this.setAnnouncementBarOffset();

        window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
          this.setHeaderHeight();
          this.setAnnouncementBarOffset();
        });

        // Watch for announcement bar height changes
        if (this.announcementBar) {
          const resizeObserver = new ResizeObserver(() => {
            this.setAnnouncementBarOffset();
          });
          resizeObserver.observe(this.announcementBar);
        }

        // Listen for announcement bar state changes
        window.addEventListener('announcementBarHeightChanged', () => {
          this.setAnnouncementBarOffset();
        });
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      setAnnouncementBarOffset() {
        if (this.announcementBar) {
          const announcementBarHeight = this.announcementBar.offsetHeight;
          
          // Check the section wrapper (like we check .section-header for header)
          const announcementBarSection = this.announcementBar.closest('.announcement-bar-section');
          const isSticky = announcementBarSection && announcementBarSection.classList.contains('shopify-section-announcement-bar-sticky');
          const isHidden = announcementBarSection && announcementBarSection.classList.contains('shopify-section-announcement-bar-hidden');
          
          if (isSticky && !isHidden) {
            document.documentElement.style.setProperty('--announcement-bar-offset', `${announcementBarHeight}px`);
          } else {
            document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
          }
        } else {
          document.documentElement.style.setProperty('--announcement-bar-offset', '0px');
        }
      }
    }
  
    customElements.define('static-header', StaticHeader);
  
  } catch(e) { console.error(e); }
})();
})();
